module.exports = __webpack_public_path__ + "static/img/sort.9f2b999d.png";